import {
	Component,
	OnInit,
	OnDestroy,
	Input,
	ViewChild,
	AfterViewInit
} from '@angular/core';
import { Location } from '@angular/common';
import { IMyDpOptions } from 'mydatepicker';
import { DragulaService } from 'ng2-dragula';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import {
	Quotes,
	Product,
	PaymentSchedule,
	Contract,
	JobQuestionnarie,
	QuotePayments,
	QuoteType,
	IModalAction,
	BootstrapSettings,
	ListItem,
	PropsAction,
	ContractPayload
} from '@models/models';
import { ContractsDataProvider } from '@services/contract/contracts.data.service';
import { TemplatesDataProvider } from '@services/data-services/templates-data-service/templates.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { StringModifierServiceProvider } from '@services/helpers/string-modifier-service/stringModifier.service';
import { TimeServiceProvider } from '@services/helpers/time-service/time.service';
import { JobsDataServiceProvider } from '@services/job/jobs.data.service';
import { LeadsDataServiceProvider } from '@services/lead/leads.data.service';
import { PaymentSchedulesDataProvider } from '@services/payments/payments-schedules-data-service/payments-schedules.data.service';
import { QuestionnairesDataProvider } from '@services/questionnarie/questionnaires.data.service';
import { QuotesDataProvider } from '@services/quote/quotes-data-service/quotes.data.service';
import { ProductPackagesDataServiceProvider } from '@services/settings/product-packages.data.service';
import { SettingsProvider } from '@services/settings/settings';
import { QuoteUpdateService } from '@services/quote/quote-update.service';
import { PaymentScheduleComponent } from '@web-components/quotes/common/payment-schedule/payment-schedule';
import { filter, finalize, map, takeUntil } from 'rxjs/operators';
import { ValidationProvider } from '@services/helpers/validation.service';
import { SNModalService } from '@web-services/modal/snModal.service';
import { SaveAsTemplateModalComponent } from '@web-components/quotes/modals/save-as-template-modal/save-as-template-modal.component';
import { SaveNewTemplateModalComponent } from '@web-components/quotes/modals/save-new-template-modal/save-new-template-modal.component';
import {
	QtBaseData,
	QtItemPayload,
	QTSaveDataPayload,
	QtTemplateListItem
} from '@models/qt-templates.model';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { diff } from 'deep-object-diff';
import { EditContractModalComponent } from '@web-components/contract/edit-contract-modal/edit-contract-modal.component';
import { ConfirmGeneralModalComponent } from '@web-components/common/confirm-general-modal/confirm-general-modal.component';
import { QuoteInvoiceTemplatesDataService } from '@services/quote-invoice-templates/quote-invoice-templates.data.service';
import { QuoteInvoiceTemplatesService } from '@services/quote-invoice-templates/quote-invoice-templates.service';

@Component({
	selector: 'quote-update',
	template: require('./quote-update.html'),
	styles: [require('./quote-update.scss')]
})
export class QuoteUpdateComponent implements OnInit, OnDestroy, AfterViewInit {
	@Input('idToGetQuote') idToGetQuote: number;
	@Input('isJob') isJob: boolean;
	@Input('quoteId') quoteId: number;
	@Input('quoteType') quoteType: QuoteType;
	@ViewChild('paymentScheduleComponent')
	paymentScheduleComponent: PaymentScheduleComponent;
	@ViewChild('quoteTemplateSelect')
	quoteTemplateSelect: { nativeElement: HTMLSelectElement };
	buttonDisable = false;
	datePlaceHolder = '';

	quoteTemplatesAvailable: boolean;
	autoGenerateInvoice = true;
	quote: Quotes;
	packages: Array<Product> = [];
	addons: Array<Product> = [];
	discounts: Array<Product> = [];
	currencyAndTax;
	paymentSchedule: PaymentSchedule;
	paymentScheduleTemplateId = 0;
	paymentScheduleIdFromServer: number;
	contract: Contract;
	currentContractId: number;
	contractTextSnapshot: string;
	questionnaire: JobQuestionnarie;
	questionnaireToSaveId = '-1';
	questionnaireTemplates: Array<ListItem> = [];
	contractToSaveId = '-1';
	contractToSave = null;
	contractsTemplates: Array<ListItem> = [];
	linkedContract: Contract;
	paymentsToSave = null;
	paymentsFromServer = [];
	packagesNames;
	addonsNames;
	discountsNames;
	paymentScheduleNames;
	defaultPaymentScheduleNames;
	products: Array<Product> = [];
	productsNames = [];
	payments = [];
	quoteTemplates: Array<QtTemplateListItem> = [];
	issueDate = null;
	now: string;
	editQuote = false;
	quoteSummary;
	job;
	leadId: number;
	selectedPaymentSchedule;
	defaultIntroductions;

	initialDataAsTemplate: QtItemPayload = null;
	selectedQuoteTemplate: QtItemPayload;
	selectedQuoteTemplateId = '-1';
	loadingTemplate: boolean;
	currencyFlag = false;
	contractFlag = false;
	generateInvoiceDisabled = false;

	myDatePickerOptions: IMyDpOptions;
	unsubscribe: Subject<void> = new Subject<void>();
	dragulaPackagesOptions = {
		moves: (el, container, handle): boolean =>
			handle.classList.contains('handle-package')
	};
	dragulaProductsOptions = {
		moves: (el, container, handle): boolean =>
			handle.classList.contains('handle-package')
	};
	dragulaDiscountsOptions = {
		moves: (el, container, handle): boolean =>
			handle.classList.contains('handle-package')
	};

	constructor(
		private dragulaService: DragulaService,
		private stringModifierService: StringModifierServiceProvider,
		private quoteDataService: QuotesDataProvider,
		private messageService: MessageService,
		private timeService: TimeServiceProvider,
		private templatesDataService: TemplatesDataProvider,
		private questionnairesDataService: QuestionnairesDataProvider,
		private productPackagesDataService: ProductPackagesDataServiceProvider,
		private contractDataService: ContractsDataProvider,
		private quoteUpdateService: QuoteUpdateService,
		private paymentsSchedulesDataService: PaymentSchedulesDataProvider,
		private jobDataService: JobsDataServiceProvider,
		private leadDataService: LeadsDataServiceProvider,
		private settingsService: SettingsProvider,
		private location: Location,
		private quotesDataService: QuotesDataProvider,
		private validationService: ValidationProvider,
		private modalService: SNModalService,
		private qtTemplatesDataService: QuoteInvoiceTemplatesDataService,
		private qtTemplatesService: QuoteInvoiceTemplatesService,
		private contractsDataService: ContractsDataProvider
	) {}

	ngOnInit(): void {
		this.now = this.quoteUpdateService.getNow();
		if (this.quoteId && this.isJob) {
			this.getQuoteSourceData();
			this.editQuote = true;
		} else if (this.quoteId && !this.isJob) {
			this.getJobId(true);
			this.editQuote = true;
		} else if (!this.quoteId && this.isJob) {
			this.showNewQuote();
		} else {
			this.getJobId(false);
		}

		this.getProductsTemplates();
		this.getBootstrapSettings();
		this.setDragulaOptions();
	}

	ngAfterViewInit(): void {
		this.registerUpdateProductSubscription();
	}

	ngOnDestroy(): void {
		this.clear();
	}

	// PRODUCT AND PACKAGES SECTION
	addNewPackage(): void {
		const productToAdd = JSON.parse(
			JSON.stringify(QuoteUpdateService.setEmptyProduct('PACKAGE'))
		);
		this.packages.push(productToAdd);
	}

	addNewAddon(): void {
		const productToAdd = JSON.parse(
			JSON.stringify(QuoteUpdateService.setEmptyProduct('ADD_ON'))
		);
		this.addons.push(productToAdd);
	}

	addNewDiscount(): void {
		const productToAdd = JSON.parse(
			JSON.stringify(QuoteUpdateService.setEmptyProduct('GIFT'))
		);
		this.discounts.push(productToAdd);
		this.updateQuoteSummary(true);
	}

	addNewProduct(): void {
		const productToAdd = JSON.parse(
			JSON.stringify(QuoteUpdateService.setEmptyProduct('ADD_ON'))
		);
		productToAdd.mandatory = true;
		this.products.push(productToAdd);
		this.updateQuoteSummary(true);
	}

	removePackage(itemToDelete): void {
		if (itemToDelete.type === 'package') {
			this.packages.splice(itemToDelete.index, 1);
			if (this.packages.length === 1) {
				this.packages[0].recommended = false;
			}
		} else if (itemToDelete.type === 'product') {
			this.addons.splice(itemToDelete.index, 1);
		}
	}

	removeDiscount(index) {
		this.discounts.splice(index, 1);
		this.updateQuoteSummary(true);
	}

	removeFixedQuoteProduct(itemToDelete): void {
		this.products.splice(itemToDelete.index, 1);
		this.updateQuoteSummary(true);
	}

	// CHANGE STATE SECTION
	setQuestionnaire(questionnaireId: string): void {
		this.questionnaireToSaveId = questionnaireId;
	}

	setContract(contractId: string): void {
		this.contractTextSnapshot = null;
		this.contractToSaveId = contractId;
		this.getContractToEdit(contractId);
	}

	disableButtons(isDisable): void {
		this.buttonDisable = isDisable;
	}

	setRecommended(index): void {
		this.packages.forEach((packageItem, packageIndex): void => {
			if (packageIndex !== index) {
				packageItem.recommended = false;
			}
		});
	}

	setPaymentScheduleId(payments): void {
		this.paymentScheduleTemplateId = +payments.id;
		this.paymentsToSave =
			this.paymentScheduleTemplateId === -3 ? [] : payments.payments;
		this.generateInvoiceDisabled = +payments.id === -3;
	}

	setNewProduct(product): void {
		if (product.type === 'package') {
			this.packages.forEach((packageItem, index) => {
				if (index === product.index) {
					this.packages[index] = JSON.parse(
						JSON.stringify(Object.assign({}, product.product))
					);
				}
			});
		} else if (product.type === 'discount') {
			this.discounts.forEach((discount, index) => {
				if (index === product.index) {
					this.discounts[index] = JSON.parse(
						JSON.stringify(Object.assign({}, product.product))
					);
				}
			});
		} else {
			this.addons.forEach((addon, index) => {
				if (index === product.index) {
					this.addons[index] = JSON.parse(
						JSON.stringify(Object.assign({}, product.product))
					);
				}
			});
		}
	}

	setNewFixedQuoteProduct(product): void {
		this.products.forEach((packageItem, index) => {
			if (index === product.index) {
				this.products[index] = JSON.parse(
					JSON.stringify(Object.assign({}, product.product))
				);
			}
		});
	}

	updateFixedQuoteProductProperties(product): void {
		this.products.forEach((packageItem, index) => {
			if (index === product.index) {
				this.products[index].price = product.product.price;
				this.products[index].quantity = product.product.quantity;
				this.products[index].discount = product.product.discount;
				this.products[index].taxType = product.product.taxType;
				this.products[index].amount = product.product.amount;
			}
		});
	}

	updateQuoteSummary(needToUpdatePayments): void {
		// setTimeout fixes issue on Safari when id of product changes with delay

		setTimeout(() => {
			const productsToCalculate =
				this.quoteType === 'custom'
					? this.getProductsToSave(false)
					: this.getProductsToSaveFixedQuote(false);
			if (productsToCalculate && this.currencyAndTax) {
				this.quotesDataService
					.calculateProductsSummary(
						productsToCalculate,
						this.currencyAndTax.percentage,
						this.currencyAndTax.currency.symbol
					)
					.subscribe(
						data =>
							this.successUpdatePricesCalculation(
								data,
								needToUpdatePayments,
								productsToCalculate
							),
						error => this.messageService.showDefaultErrorMessage(error)
					);
			}
		}, 0);
	}

	private successUpdatePricesCalculation(
		data: any,
		needToUpdatePayments,
		productsToCalculate
	): void {
		this.quoteSummary = data;
		this.quoteSummary.taxName = this.currencyAndTax.taxName;
		if (
			this.job &&
			this.quote &&
			this.paymentScheduleNames &&
			needToUpdatePayments &&
			productsToCalculate.length > 0
		) {
			this.paymentScheduleComponent.getPaymentScheduleNew(
				this.paymentScheduleTemplateId,
				true,
				this.quoteSummary.total
			);
		} else if (
			this.quoteType &&
			this.quoteSummary &&
			this.quoteSummary.total === 0
		) {
			setTimeout(() => {
				this.paymentScheduleComponent.hideAndResetPaymentSchedule();
			}, 500);
		}
	}

	registerUpdateProductSubscription(): void {
		this.quoteUpdateService.updatedProductObservable
			.pipe(
				takeUntil(this.unsubscribe),
				filter((product): boolean => product !== null)
			)
			.subscribe(updatedProduct => {
				if (this.quoteType === 'fixed') {
					this.updateFixedQuoteProductProperties(updatedProduct);
				} else {
					this.formProducts();
				}

				if (
					this.quoteUpdateService.validateProductsPropsDefined(this.products)
				) {
					this.updateQuoteSummary(true);
				}
			});
	}

	private formProducts() {
		this.products = [];
		this.packages.forEach(packageItem => {
			this.products.push(packageItem);
		});
		this.addons.forEach(addon => {
			this.products.push(addon);
		});

		this.discounts.forEach(discount => {
			this.products.push(discount);
		});
	}

	// SAVE QUOTE SECTION
	saveQuote(): void {
		this.buttonDisable = true;
		if (!this.validateQuote()) {
			this.buttonDisable = false;
			return;
		}

		const data = this.gatherDataToSaveQuote();

		if (this.editQuote) {
			this.updateQuote(data);
		} else {
			this.createQuote(data);
		}
	}

	confirmApplyQuoteTemplate(templateId: string): void {
		if (this.isTemplateDataDiff()) {
			this.confirmTemplateChange()
				.then((): void => this.applyQuoteTemplate(templateId))
				.catch((): void => {
					this.quoteTemplateSelect.nativeElement.value = this.selectedQuoteTemplateId;
				});
		} else {
			this.applyQuoteTemplate(templateId);
		}
	}

	private applyQuoteTemplate(templateId: string): void {
		this.selectedQuoteTemplateId = templateId;

		if (templateId === '-1') {
			this.resetTemplateData();
			return;
		}

		this.loadingTemplate = true;
		this.qtTemplatesDataService
			.loadQtTemplate(templateId, 'QUOTE')
			.pipe(
				takeUntil(this.unsubscribe),
				finalize((): boolean => (this.loadingTemplate = false))
			)
			.subscribe(
				({ data }): void => this.applyQuoteTemplateData(data),
				(error): void => {
					this.selectedQuoteTemplateId = '-1';
					this.messageService.handleError(error);
				}
			);
	}

	private applyQuoteTemplateData(data: QtItemPayload): void {
		this.selectedQuoteTemplate = JSON.parse(JSON.stringify(data));
		this.modifyContractBodyForDiff(data.contractTemplate);
		this.modifyProductsForDiff(data.products);
		this.selectedQuoteTemplate.notes = this.selectedQuoteTemplate.notes || '';

		this.setPackagesAndAddons(data.products);
		this.quote.introduction = data.introduction;
		this.quote.notes = data.notes || '';
		this.autoGenerateInvoice = data.generateInvoiceWhenAccepted;

		this.getTemplatePayments(data);
		if (data.payments) {
			this.payments = data.payments;
		} else {
			this.payments = [];
		}

		this.contractToSaveId = data.contractTemplate
			? data.contractTemplate.id.toString()
			: '-1';
		this.questionnaireToSaveId = data.questionnaireTemplate
			? data.questionnaireTemplate.id.toString()
			: '-1';

		this.getContractToEdit(this.contractToSaveId);
		this.updateQuoteSummary(true);
	}

	private getTemplatePayments(data) {
		const rule = data.paymentsRule;
		if (rule) {
			switch (rule.strategy) {
				case 'NO_SPLIT_PAYMENTS':
					this.paymentScheduleTemplateId = -2;
					break;
				case 'NO_DUE_DATE':
					this.paymentScheduleTemplateId = -3;
					break;
				case 'BY_PAYMENT_SCHEDULER':
					const paymentScdl = rule.paymentSchedule;
					if (paymentScdl) {
						const check = this.paymentScheduleNames.some(
							el => el.id === paymentScdl.id
						);
						if (!check) {
							this.paymentScheduleNames.push({
								...paymentScdl
							});
						}
						this.paymentScheduleTemplateId = paymentScdl.id.toString();
					}
					break;
				default:
					this.paymentScheduleTemplateId = -2;
			}
		} else {
			if (data.paymentSchedule) {
				const check = this.paymentScheduleNames.some(
					el => el.id === data.paymentSchedule.id
				);
				if (!check) {
					this.paymentScheduleNames.push({
						...data.paymentSchedule
					});
				}
			}
			this.paymentScheduleTemplateId = data.paymentSchedule
				? data.paymentSchedule.id.toString()
				: -1;
		}
	}

	private resetTemplateData(): void {
		const type = this.quoteType === 'fixed' ? 'FIXED' : 'CHOOSE_AND_PICK';
		let emptyTemplateData: QtItemPayload = null;

		if (this.editQuote) {
			emptyTemplateData = JSON.parse(
				JSON.stringify(this.initialDataAsTemplate)
			);
		} else {
			this.selectedPaymentSchedule = null;
			const desiredEmptyProduct =
				this.quoteType === 'fixed'
					? QuoteUpdateService.setEmptyProduct('ADD_ON')
					: QuoteUpdateService.setEmptyProduct('PACKAGE');
			desiredEmptyProduct.mandatory = true;

			emptyTemplateData = QuoteInvoiceTemplatesService.getEmptyQtItem(
				type,
				desiredEmptyProduct,
				this.quoteType === 'fixed'
					? this.defaultIntroductions.fixedIntroduction
					: this.defaultIntroductions.chooseAndPickIntroduction
			);
		}
		this.applyQuoteTemplateData(emptyTemplateData);
	}

	private isTemplateDataDiff(): boolean {
		const dataDiff = diff(
			this.qtTemplatesService.prepareQuoteInvoiceDataForDiff(
				this.selectedQuoteTemplate
			),
			this.qtTemplatesService.prepareQuoteInvoiceDataForDiff(
				this.gatherQtDataForDiff()
			)
		);
		return !!Object.keys(dataDiff).length;
	}

	private gatherQtDataForDiff(): Partial<QtItemPayload> {
		const paymentSchedule =
			this.paymentScheduleTemplateId === -1 ||
			this.paymentScheduleTemplateId === -2 ||
			this.paymentScheduleTemplateId === -3
				? null
				: this.qtTemplatesService.findTemplateItemById(
						this.paymentScheduleNames,
						this.paymentScheduleTemplateId
				  );

		const questionnaireTemplate =
			this.questionnaireToSaveId === '-1'
				? null
				: this.qtTemplatesService.findTemplateItemById(
						this.questionnaireTemplates,
						this.questionnaireToSaveId
				  );

		return {
			...this.selectedQuoteTemplate,
			products:
				this.quoteType === 'fixed'
					? this.qtTemplatesService.prepareProductsForDiff([
							...this.products,
							...this.discounts
					  ])
					: this.qtTemplatesService.prepareProductsForDiff([
							...this.packages,
							...this.addons,
							...this.discounts
					  ]),
			introduction: this.quote.introduction,
			notes: this.quote.notes,
			generateInvoiceWhenAccepted: this.autoGenerateInvoice,
			contractTemplate: this.contractToSave
				? {
						id: this.contractToSave.id,
						text: this.contractToSave.text
				  }
				: null,
			paymentSchedule,
			questionnaireTemplate
		};
	}

	private modifyContractBodyForDiff(contract: Contract): void {
		if (contract) {
			this.selectedQuoteTemplate.contractTemplate = {
				id: contract.id,
				text: contract.text
			};
		}
	}

	private modifyProductsForDiff(products: Array<Product>) {
		if (products.length) {
			this.selectedQuoteTemplate.products = this.qtTemplatesService.prepareProductsForDiff(
				products
			);
		}
	}

	private confirmTemplateChange(): Promise<void> {
		return new Promise((resolve, reject): void => {
			const modal = this.modalService.openModal(ConfirmGeneralModalComponent);
			modal.componentInstance.text =
				'This quote has unsaved changes. Are you sure you want to replace it with a template? Some data may be lost.';
			modal.componentInstance.buttons = [
				{
					text: 'Yes',
					color: 'success',
					size: 'lg',
					action: 'APPLY_TEMPLATE'
				},
				{
					text: 'No',
					color: 'default',
					size: 'lg',
					action: 'CANCEL'
				}
			];

			modal.result.then((action: string): void => {
				if (action === 'APPLY_TEMPLATE') {
					resolve();
				}
				if (action === 'CANCEL') {
					reject();
				}
			});
		});
	}

	saveAsTemplate(): void {
		const payload = this.validateAndGatherTemplate('Test Name');

		if (payload) {
			if (!this.validateContractEditing()) {
				return;
			}

			const modal = this.modalService.openModal(SaveAsTemplateModalComponent, {
				windowClass: 'ng-bootstrap-modal'
			});
			modal.componentInstance.templateList = this.quoteTemplates;
			modal.componentInstance.templateTypeName =
				this.quoteType === 'custom' ? 'Pick & Choose Quote' : 'Fixed Quote';
			modal.componentInstance.templateNameTitle = 'Quote';
			modal.componentInstance.breadcrumbsText =
				'Quote Templates will be saved in Settings > Quote & Invoice Templates';

			const modalSubscription$ = this.modalService.modalData.subscribe(
				(data: IModalAction<ListItem>): void => {
					const closeModal = (): void => {
						this.modalService.closeModalByRef(modal, modalSubscription$);
					};

					this.handleSaveAsTemplateResponse(
						data,
						modal,
						payload,
						closeModal.bind(this)
					);
				}
			);
		}
	}

	saveNewTemplate(payload: QTSaveDataPayload): void {
		const modal = this.modalService.openModal(SaveNewTemplateModalComponent, {
			windowClass: 'ng-bootstrap-modal'
		});
		modal.componentInstance.templateTypeName =
			this.quoteType === 'custom' ? 'Pick & Choose Quote' : 'Fixed Quote';
		modal.componentInstance.templateNameTitle = 'Quote';
		modal.componentInstance.breadcrumbsText =
			'Quote Templates will be saved in Settings > Quote & Invoice Templates';
		modal.componentInstance.templateNameProp = this.selectedQuoteTemplate.name;

		const modalSubscription$ = this.modalService.modalData.subscribe(
			(data: IModalAction<string>): void => {
				const closeModal = (): void => {
					this.modalService.closeModalByRef(modal, modalSubscription$);
				};

				this.handleSaveNewTemplateResponse(
					data,
					modal,
					payload,
					closeModal.bind(this)
				);
			}
		);
	}

	private handleSaveNewTemplateResponse(
		data: IModalAction<string>,
		modalRef: NgbModalRef,
		payload: QTSaveDataPayload,
		closeModal: Function
	): void {
		if (data.action === 'CLOSE') {
			this.saveAsTemplate();
			closeModal();
		}

		if (data.action === 'SAVE') {
			if (!data.props) {
				if (!data.props || (data.props && !data.props.trim())) {
					this.messageService.showToaster(
						'e_4',
						'quoteInvoiceTemplates',
						'quote'
					);
					return null;
				}
			}

			const dataToSave = JSON.parse(JSON.stringify(payload));
			dataToSave.data.name = data.props;

			modalRef.componentInstance.btnDisable = true;
			this.qtTemplatesDataService
				.saveTemplate(
					this.quoteType === 'fixed' ? 'QUOTE' : 'CUSTOM_QUOTE',
					dataToSave
				)
				.pipe(
					takeUntil(this.unsubscribe),
					finalize(
						(): boolean => (modalRef.componentInstance.btnDisable = false)
					)
				)
				.subscribe(
					({ data }): void => {
						closeModal();
						this.loadQuoteTemplates();
						this.selectedQuoteTemplateId = data.id;
						this.selectedQuoteTemplate.name = data.name;
						this.messageService.showToaster(
							's_7',
							'quoteInvoiceTemplates',
							data.name
						);
						localStorage.setItem(
							'keyToScroll',
							this.quoteType === 'fixed' ? 'fixed' : 'pick_and_choose'
						);
						window.open(`${location.origin}/settings/quote_invoice_templates`);
					},
					(error): void => this.messageService.handleError(error)
				);
		}
	}

	private handleSaveAsTemplateResponse(
		data: IModalAction<ListItem>,
		modalRef: NgbModalRef,
		payload: QTSaveDataPayload,
		closeModal: Function
	): void {
		if (data.action === 'CLOSE') {
			closeModal();
		}

		if (data.action === 'SAVE') {
			closeModal();
			this.saveNewTemplate(payload);
		}

		if (data.action === 'OVERWRITE') {
			if (!data.props) {
				this.messageService.showToaster('e_2', 'quoteInvoiceTemplates');
				return;
			}

			const dataToSave = JSON.parse(JSON.stringify(payload));
			dataToSave.data.name = data.props.name;

			modalRef.componentInstance.btnDisable = true;
			this.qtTemplatesDataService
				.editTemplate(
					this.quoteType === 'fixed' ? 'QUOTE' : 'CUSTOM_QUOTE',
					data.props.id.toString(),
					dataToSave
				)
				.pipe(
					takeUntil(this.unsubscribe),
					finalize(
						(): boolean => (modalRef.componentInstance.btnDisable = false)
					)
				)
				.subscribe(
					({ data }): void => {
						this.messageService.showToaster(
							's_1',
							'quoteInvoiceTemplates',
							'quote'
						);
						this.selectedQuoteTemplateId = data.id;
						closeModal();
					},
					(error): void => this.messageService.handleError(error)
				);
		}
	}

	private validateContractEditing(): boolean {
		if (
			this.contractTextSnapshot &&
			this.validationService.trimHTML(this.contractTextSnapshot) !==
				this.validationService.trimHTML(this.contractToSave.text)
		) {
			this.confirmEditingContract(this.contractToSave);
			return false;
		}
		return true;
	}

	private confirmEditingContract(contract: Contract): void {
		if (contract) {
			const modal = this.modalService.openModal(SaveAsTemplateModalComponent, {
				windowClass: 'ng-bootstrap-modal'
			});
			modal.componentInstance.templateList = this.contractsTemplates;
			modal.componentInstance.templateTypeName = 'Contract';
			modal.componentInstance.templateNameTitle = 'Contract';
			modal.componentInstance.breadcrumbsText =
				'Contract Templates will be saved in Settings > Contract Templates';
			modal.componentInstance.detailedDescription =
				'Your contract has been edited and will need to be saved as a Contract Template.';

			const modalSubscription$ = this.modalService.modalData.subscribe(
				(res: IModalAction<ListItem>): void => {
					if (res.action === 'CLOSE') {
						this.modalService.closeModalByRef(modal, modalSubscription$);
					}

					if (res.action === 'SAVE') {
						this.modalService.closeModalByRef(modal, modalSubscription$);
						this.saveNewContractTemplate(contract);
					}

					if (res.action === 'OVERWRITE') {
						if (!res.props) {
							this.messageService.showToaster('e_2', 'quoteInvoiceTemplates');
							return;
						}

						modal.componentInstance.btnDisable = true;
						const newContract = {
							...res.props,
							text: this.contractToSave.text
						} as ContractPayload;

						this.contractsDataService
							.overwriteContractTemplate(
								res.props.templateId.toString(),
								newContract
							)
							.pipe(
								takeUntil(this.unsubscribe),
								finalize(
									(): boolean => (modal.componentInstance.btnDisable = false)
								)
							)
							.subscribe(
								({ data }): void => {
									this.messageService.showToaster(
										's_2',
										'contractTemplates',
										contract.name
									);
									this.contractToSaveId = data.id.toString();
									this.contractToSave = data;
									this.modalService.closeModalByRef(modal, modalSubscription$);
									this.contractTextSnapshot = null;
									this.saveAsTemplate();
								},
								(error): void => this.messageService.handleError(error)
							);
					}
				}
			);
		}
	}

	private saveNewContractTemplate(contract: Contract): void {
		const modal = this.modalService.openModal(SaveNewTemplateModalComponent, {
			windowClass: 'ng-bootstrap-modal'
		});
		modal.componentInstance.templateTypeName = 'Contract';
		modal.componentInstance.templateNameTitle = 'Contract';
		modal.componentInstance.breadcrumbsText =
			'Contract Templates will be saved in Settings > Contract Templates';
		modal.componentInstance.templateNameProp = contract.name;

		const modalSubscription$ = this.modalService.modalData.subscribe(
			(res: IModalAction<string>): void => {
				if (res.action === 'CLOSE') {
					this.confirmEditingContract(contract);
					this.modalService.closeModalByRef(modal, modalSubscription$);
				}

				if (res.action === 'SAVE') {
					if (!res.props || (res.props && !res.props.trim())) {
						this.messageService.showToaster('e_3', 'quoteInvoiceTemplates');
						return;
					}

					const newContract = JSON.parse(JSON.stringify(contract));
					newContract.name = res.props;

					modal.componentInstance.btnDisable = true;
					this.contractsDataService
						.saveNewContractTemplate(newContract)
						.pipe(
							takeUntil(this.unsubscribe),
							finalize(
								(): boolean => (modal.componentInstance.btnDisable = false)
							)
						)
						.subscribe(
							({ data }): void => {
								this.modalService.closeModalByRef(modal, modalSubscription$);
								this.messageService.showToaster(
									's_5',
									'quoteInvoiceTemplates',
									newContract.name
								);
								this.contractTextSnapshot = null;

								Observable.zip(
									this.templatesDataService.getTemplates('contract_preview'),
									this.getInitialContract()
								).subscribe(([contractTemplates, contractData]): void => {
									const contract = contractData ? contractData.contract : null;
									this.contractsTemplates = contractTemplates.contractTemplates;

									if (data) {
										this.setContractSources(data);
									} else if (contract) {
										this.qtTemplatesService.addSelectedTemplate(
											this.contractsTemplates,
											{
												...contract,
												templateId: contract.id
											}
										);

										this.linkedContract = contract;
										this.setContractSources(contract);
									}
									this.saveAsTemplate();
								});
							},
							(error): void => this.messageService.handleError(error)
						);
				}
			}
		);
	}

	private validateAndGatherTemplate(
		templateName: string
	): QTSaveDataPayload | null {
		const gatheredProducts =
			this.quoteType === 'fixed'
				? [...this.products, ...this.discounts]
				: [...this.packages, ...this.addons, ...this.discounts];
		const paymentScheduleTemplateId =
			this.paymentScheduleTemplateId !== 0
				? this.paymentScheduleTemplateId
				: this.paymentScheduleIdFromServer;

		const data = {
			contractTemplateId: this.contractToSave
				? this.contractToSave.id.toString()
				: null,
			questionnaireTemplateId: this.questionnaireToSaveId
				? this.questionnaireToSaveId.toString()
				: null,
			paymentSchedulerTemplateId: paymentScheduleTemplateId
				? paymentScheduleTemplateId.toString()
				: null,
			data: {
				products: this.qtTemplatesService.mapLineItems(gatheredProducts),
				name: templateName,
				notes: this.quote.notes,
				introduction: this.quote.introduction,
				generateInvoiceWhenAccepted: this.autoGenerateInvoice
			}
		} as Partial<QtBaseData>;

		if (
			!this.qtTemplatesService.validateSelectedTemplates(
				data,
				this.contractsTemplates,
				this.questionnaireTemplates,
				'QUOTE'
			)
		) {
			return null;
		}

		if (!this.qtTemplatesService.validateQuoteTemplate(data)) {
			return null;
		}

		return this.qtTemplatesService.prepareTemplateForSave(data);
	}

	private assignInitialDataAsTemplate(quote: Quotes, contract: Contract): void {
		this.initialDataAsTemplate = this.qtTemplatesService.createTemplateDataFromQuote(
			quote,
			contract,
			this.quoteType === 'fixed' ? 'FIXED' : 'CHOOSE_AND_PICK'
		);
		this.selectedQuoteTemplate = JSON.parse(
			JSON.stringify(this.initialDataAsTemplate)
		);
		this.modifyContractBodyForDiff(contract);
		this.modifyProductsForDiff(
			this.editQuote ? quote.products : [...this.packages, ...this.products]
		);
	}

	private validateQuote(): boolean {
		const products =
			this.quoteType === 'custom'
				? this.getProductsToSave(false)
				: this.getProductsToSaveFixedQuote(false);
		let invalidProductType;
		if (
			products.find(
				product => product.type === 'GIFT' && !product.mandatory
			) !== undefined
		) {
			this.messageService.showToaster('e_6', 'editQuote');
			return false;
		}
		if (
			products.find(
				product => product.type === 'GIFT' && parseInt(product.quantity) !== 1
			) !== undefined
		) {
			this.messageService.showToaster('e_10', 'editQuote');
			return false;
		}
		if (
			products.find(
				product => product.type === 'GIFT' && product.price >= 0
			) !== undefined
		) {
			this.messageService.showToaster('e_16', 'editQuote');
			return false;
		}
		if (
			products.find(product => product.type === 'GIFT') !== undefined &&
			products.find(product => product.taxType !== products[0].taxType) !==
				undefined
		) {
			this.messageService.showToaster('e_13', 'editQuote');
			return false;
		}
		if (products.length === 0) {
			this.messageService.showToaster('e_4', 'editQuote');
			return false;
		}
		if (
			this.quote.ponumber !== null &&
			!this.quote.ponumber.match(
				'^[a-zA-Z0-9 *№\'ʼ;:%!?@#$&|>\\<{}()-`.+,/"]*$'
			)
		) {
			this.messageService.showToaster('e_7', 'editQuote');
			return false;
		}
		if (
			products.find(product => {
				if (product.name === '') {
					invalidProductType = product.type;
					if (invalidProductType === 'GIFT') {
						invalidProductType = 'discount';
					} else if (invalidProductType === 'ADD_ON') {
						invalidProductType = 'product';
					}
					return true;
				}
			})
		) {
			this.messageService.showToaster(
				'e_0',
				'productsPackages',
				invalidProductType.toLowerCase()
			);
			return false;
		}
		if (products.find(product => product.quantity <= 0) !== undefined) {
			this.messageService.showToaster('e_8', 'editQuote');
			return false;
		}
		if (
			products.find(product => {
				const escapedProduct = product.description
					? this.validationService.trimHTML(product.description).trim()
					: '';

				if (
					product.type !== 'GIFT' &&
					(!product.description ||
						product.description.length === 0 ||
						!escapedProduct)
				) {
					invalidProductType =
						product.type.toUpperCase() === 'PACKAGE' ? 'package' : 'product';
					return true;
				}
			})
		) {
			this.messageService.showToaster('e_9', 'editQuote', invalidProductType);
			return false;
		}
		if (
			products.find(product => {
				if (product.name.trim().length === 0) {
					if (product.type.toUpperCase() === 'GIFT') {
						invalidProductType = 'Discount';
					} else {
						invalidProductType =
							product.type.toUpperCase() === 'PACKAGE' ? 'Package' : 'Product';
					}
					return true;
				}
			})
		) {
			this.messageService.showToaster('e_14', 'editQuote', invalidProductType);
			return false;
		}
		if (products.find(product => product.discount > 100) !== undefined) {
			this.messageService.showToaster('e_2', 'editQuote');
			return false;
		}
		if (this.paymentScheduleTemplateId === -1) {
			this.messageService.showToaster('e_18', 'editQuote');
			return false;
		}
		if (
			this.paymentsToSave.find(
				payment =>
					!payment.date && !payment.paymentDateWithRule.ruleExplanationHTML
			) !== undefined
		) {
			this.messageService.showToaster('e_11', 'editQuote');
			return false;
		}

		const invalidCounter = document.querySelector('.counter.red');
		if (invalidCounter) {
			this.messageService.showToaster('e_6', 'productsPackages', '4000');
			return false;
		}
		return true;
	}

	private getBootstrapSettings(): void {
		this.settingsService.timeFormatSettings
			.pipe(takeUntil(this.unsubscribe))
			.subscribe((data: BootstrapSettings): void => {
				this.setCorrectDateFormat(data.dateFormat);
				this.quoteTemplatesAvailable = data.qtTemplatesAvailable;
			});
	}

	private setCorrectDateFormat(format: string): void {
		switch (format) {
			case 'DD_MM_YYYY':
				this.datePlaceHolder = 'dd/mm/yyyy';
				break;
			case 'MM_DD_YYYY':
				this.datePlaceHolder = 'mm/dd/yyyy';
				break;
			default:
				this.datePlaceHolder = '';
				break;
		}
	}

	private getJobId(makeQuoteRequest): void {
		this.leadId = this.idToGetQuote;
		this.quoteDataService.getJobId(this.idToGetQuote).subscribe(
			(data): void => {
				this.idToGetQuote = data;
				if (makeQuoteRequest) {
					this.getQuoteSourceData();
				} else {
					this.showNewQuote();
				}
			},
			(error): void => this.messageService.showDefaultErrorMessage(error)
		);
	}

	// DRAG'N'DROP SECTION
	private setDragulaOptions(): void {
		this.dragulaService.setOptions('products', this.dragulaProductsOptions);
		this.dragulaService.setOptions('packages', this.dragulaPackagesOptions);
		this.dragulaService.setOptions('discounts', this.dragulaDiscountsOptions);
	}

	private clear(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.quoteUpdateService.setNextUpdateProduct(null, null);
		this.dragulaService.destroy('products');
		this.dragulaService.destroy('packages');
		this.dragulaService.destroy('discounts');
	}

	// GET QUOTE DATA SECTION
	private getQuoteSourceData(): void {
		this.quoteDataService
			.getQuoteToEditV1(this.idToGetQuote, this.quoteId)
			.subscribe(
				(data): void => {
					this.successGetQuoteData(data);
					this.getPaymentsSchedules();
				},
				(error): void => this.messageService.showDefaultErrorMessage(error)
			);
	}

	changeAutoGenerateInvoice(val: boolean): void {
		this.autoGenerateInvoice = val;
	}

	private setPackagesAndAddons(products): void {
		const sortedProducts = QuoteUpdateService.sortProducts(products);
		if (this.quoteType === 'custom') {
			const {
				packages,
				addons,
				discounts
			} = QuoteUpdateService.setPackagesAndAddons(sortedProducts);
			this.packages = packages;
			this.addons = addons;
			this.products = sortedProducts;
			this.discounts = discounts;
		} else {
			const {
				addons,
				discounts
			} = QuoteUpdateService.separateDiscountsAndProducts(sortedProducts);
			this.products = addons;
			this.discounts = discounts;
		}
	}

	private setPackagesAndAddonsNames(products): void {
		const {
			packages,
			addons,
			discounts
		} = QuoteUpdateService.setPackagesAndAddons(products);
		this.packagesNames = packages;
		this.addonsNames = addons;
		this.discountsNames = discounts;
	}

	private showNewQuote(): void {
		this.paymentScheduleTemplateId = -2;
		this.selectedPaymentSchedule = null;
		this.getQuoteIdAndDate(this.idToGetQuote);

		if (this.isJob) {
			this.getJobInfo();
		} else {
			this.getLeadInfo();
		}

		this.loadQuoteTemplates();
		this.getPaymentsSchedules();
	}

	private getJobInfo(): void {
		this.jobDataService
			.getJobInfo(this.idToGetQuote)
			.subscribe(
				data => (this.job = data),
				(error): void => this.messageService.showDefaultErrorMessage(error)
			);
	}

	private getLeadInfo(): void {
		this.leadDataService.getLeadInfo(this.leadId).subscribe(
			(data): void => this.successGetLead(data),
			(error): void => {
				const { errorCode, data } = error.error;
				if (errorCode === 701) {
					this.redirectToJobLead(data);
					return;
				}

				this.messageService.showDefaultErrorMessage(error);
			}
		);
	}

	private redirectToJobLead(data): void {
		this.location.go(`/${data.redirectTo}s/view/${data.redirectId}`);
	}

	private successGetLead(data): void {
		this.job = data.job;
	}

	private getCurrencyAndTaxes(): void {
		this.settingsService.getCurrencyAndTaxes().subscribe(
			(data): void => {
				this.successGetCurrencyAndTaxes(data);
			},
			(error): void => this.messageService.showDefaultErrorMessage(error)
		);
	}

	private successGetCurrencyAndTaxes(data): void {
		this.currencyAndTax = {
			currency: {
				symbol: data.currencyDTO.symbol
			},
			percentage: data.percentage,
			taxName: data.taxName
		};
		this.currencyFlag = true;
	}

	private getDefaultIntroduction(): void {
		this.qtTemplatesDataService
			.getQuoteIntroduction()
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				({ data }): void => {
					if (this.quoteType === 'fixed') {
						this.quote.introduction =
							(data.fixedIntroduction && data.fixedIntroduction.introduction) ||
							'';
					} else {
						this.quote.introduction =
							(data.chooseAndPickIntroduction &&
								data.chooseAndPickIntroduction.introduction) ||
							'';
					}
					this.defaultIntroductions = {
						fixedIntroduction:
							(data.fixedIntroduction && data.fixedIntroduction.introduction) ||
							'',
						chooseAndPickIntroduction:
							(data.chooseAndPickIntroduction &&
								data.chooseAndPickIntroduction.introduction) ||
							''
					};

					// TODO temporary fix, need to refactor
					const interval = setInterval(() => {
						if (this.selectedQuoteTemplate) {
							this.selectedQuoteTemplate.introduction =
								this.quoteType === 'fixed'
									? this.defaultIntroductions.fixedIntroduction
									: this.defaultIntroductions.chooseAndPickIntroduction;
							clearInterval(interval);
						}
					}, 200);
				},
				(error): void => this.messageService.showDefaultErrorMessage(error)
			);
	}

	private setQuoteSources(quote): void {
		const {
			contract,
			currencyAndTax,
			paymentSchedule,
			payments,
			questionnaire,
			paymentsRule
		} = quote;

		this.currencyAndTax = currencyAndTax;
		if (paymentSchedule === null) {
			if (paymentsRule.strategy === 'NO_SPLIT_PAYMENTS') {
				this.paymentScheduleTemplateId = -2;
			} else if (paymentsRule.strategy === 'NO_DUE_DATE') {
				this.paymentScheduleTemplateId = -3;
			}
		} else {
			this.paymentScheduleIdFromServer = paymentSchedule.id;
		}
		this.payments = payments;
		this.paymentsFromServer = payments;
		this.paymentSchedule = paymentSchedule;

		if (contract !== null) {
			this.contract = contract;
		}
		if (questionnaire !== null) {
			this.questionnaireToSaveId = questionnaire.id;
			this.questionnaire = questionnaire;
		}

		this.getContractAndQuestionnaireInfo();
	}

	private getContractAndQuestionnaireInfo(): void {
		Observable.zip(
			this.templatesDataService.getTemplates('contract_preview'),
			this.templatesDataService.getTemplates('questionnaire_preview'),
			this.getInitialContract()
		).subscribe(
			([contractTemplates, questionnaireTemplates, contractData]): void => {
				const contract = contractData ? contractData.contract : null;
				this.contractsTemplates = contractTemplates.contractTemplates;
				this.questionnaireTemplates =
					questionnaireTemplates.questionnaireTemplates;

				this.qtTemplatesService.addSelectedTemplate(
					this.questionnaireTemplates,
					this.questionnaire
				);

				if (contract) {
					this.qtTemplatesService.addSelectedTemplate(this.contractsTemplates, {
						...contract,
						templateId: contract.id
					});

					this.linkedContract = contract;
					this.setContractSources(contract);
				} else {
					this.linkedContract = null;
				}
				this.contractFlag = true;
				this.assignInitialDataAsTemplate(this.quote, contract);
			},
			(error): void => this.messageService.showDefaultErrorMessage(error)
		);
	}

	private setContractSources(contract: Contract): void {
		this.contractToSave = JSON.parse(JSON.stringify(contract));
		this.contractToSaveId = contract.id.toString();
	}

	private getInitialContract(): Observable<any> {
		if (this.contract) {
			this.currentContractId = this.contract.id;
			return this.contractDataService.getContract(
				this.job.id,
				this.contract.id
			);
		}
		return new Observable((observer): void => {
			observer.next(null);
		});
	}

	private getContractToEdit(contractId): void {
		if (contractId === '-1') {
			this.contractToSave = null;
			return;
		}

		if (
			this.linkedContract &&
			contractId === this.linkedContract.id.toString()
		) {
			this.contractToSave = JSON.parse(JSON.stringify(this.linkedContract));
			return;
		}

		if (this.contractToSaveId) {
			this.buttonDisable = true;
			this.templatesDataService
				.getTemplates('contract_full', +this.contractToSaveId)
				.pipe(
					takeUntil(this.unsubscribe),
					finalize((): boolean => (this.buttonDisable = false))
				)
				.subscribe(
					(contract: Contract): void => {
						this.contractToSave = JSON.parse(JSON.stringify(contract));
					},
					(error): void => this.messageService.showDefaultErrorMessage(error)
				);
		}
	}

	openEditSelectContract(): void {
		const selectedModalRef = this.modalService.openModal(
			EditContractModalComponent,
			{
				windowClass: 'ng-bootstrap-modal modal-visible'
			}
		);
		selectedModalRef.componentInstance.isFixed = this.quoteType === 'fixed';
		selectedModalRef.componentInstance.contractToEdit = JSON.parse(
			JSON.stringify(this.contractToSave)
		);
		selectedModalRef.componentInstance.action = 'SAVE_CONTRACT';

		this.contractTextSnapshot = this.contractToSave.text;

		this.subscribeToEditContractData(selectedModalRef);
	}

	private subscribeToEditContractData(modalRef: NgbModalRef): void {
		const modalDataSubscription = this.modalService
			.getModalData()
			.subscribe((data: PropsAction<Contract>): void => {
				if (data) {
					const { action, props } = data;
					if (action === 'SAVE_CONTRACT') {
						this.saveEditedContract(props);
						this.modalService.closeModalByRef(modalRef, modalDataSubscription);
					}

					if (action === 'CLOSE_MODAL') {
						this.modalService.closeModalByRef(modalRef, modalDataSubscription);
					}
				}
			});
	}

	private saveEditedContract(contract: Contract): void {
		if (contract && contract.name) {
			contract.name = this.stringModifierService.cutSelectedText(contract.name);

			this.messageService.showToaster(
				's_2',
				'contractTemplates',
				contract.name
			);
		}
		this.contractToSave = JSON.parse(JSON.stringify(contract));
	}

	private back(): void {
		this.location.back();
	}

	private updateQuote(data): void {
		this.updateQuoteRequest(data)
			.finally((): void => {
				this.buttonDisable = false;
			})
			.subscribe(
				(quoteData): void => {
					if (quoteData.status >= 400 && quoteData.status <= 500) {
						this.errorSaveQuote(quoteData);
					} else {
						this.successSaveQuote(quoteData);
					}
				},
				(error): void => this.errorSaveQuote(error)
			);
	}

	private updateQuoteRequest(data): Observable<any> {
		if (this.quoteType === 'custom') {
			return this.quoteDataService.saveQuoteV1(
				this.idToGetQuote,
				this.quote.id,
				data
			);
		}
		return this.quoteDataService.saveFixedQuoteV1(
			this.idToGetQuote,
			this.quote.id,
			data
		);
	}

	private errorSaveQuote(error): void {
		if (error.error.errorMessage === 'Requested resource not found') {
			this.messageService.showToaster('e_0', 'editQuote');
		} else if (
			error.error.errorMessage ===
			'This Quote ID is already used. Please enter another one'
		) {
			this.messageService.showToaster('e_15', 'editQuote');
		} else {
			this.messageService.showErrorFromBackend(
				error.error.errorTitle,
				error.error.errorMessage
			);
		}
	}

	private successSaveQuote(data): void {
		this.messageService.showToaster('s_2', 'payments');
		if (this.isJob) {
			this.location.go(`jobs/${this.idToGetQuote}/quote/${data.id}`);
		} else {
			this.location.go(`leads/${this.leadId}/quote/${data.id}`);
		}
		(<any>window).Intercom('trackEvent', 'created quote');
	}

	private createQuote(data): void {
		this.createQuoteRequest(data)
			.finally((): void => {
				this.buttonDisable = false;
			})
			.subscribe(
				(data): void => {
					if (data.status >= 400 && data.status <= 500) {
						this.errorSaveQuote(data);
					} else {
						this.successSaveQuote(data);
					}
				},
				({ error }): void =>
					this.messageService.showErrorFromBackend(
						error.errorTitle,
						error.errorMessage
					)
			);
	}

	private createQuoteRequest(data): Observable<any> {
		if (this.quoteType === 'custom') {
			return this.quoteDataService.createQuoteV1(this.idToGetQuote, data);
		}
		return this.quoteDataService.createFixedQuoteV1(this.idToGetQuote, data);
	}

	private successGetQuoteData(quote): void {
		const { job, products } = quote;
		this.quote = JSON.parse(JSON.stringify(quote));
		this.job = job;
		if (!this.quoteType) {
			this.quoteType =
				quote.quoteType === 'CHOOSE_AND_PICK'
					? 'custom'
					: quote.quoteType.toLowerCase();
		}
		if (quote.paymentSchedule && quote.paymentSchedule.id) {
			this.job.paymentScheduleId = quote.paymentSchedule.id;
		}
		this.issueDate = this.quoteUpdateService.setQuoteIssueDate(quote.issueDate);
		this.autoGenerateInvoice = this.quote.generateInvoiceWhenAccepted;

		this.setQuoteSources(quote);
		this.setPackagesAndAddons(products);

		this.loadQuoteTemplates();

		this.updateQuoteSummary(false);

		if (quote.status === 'ACCEPTED') {
			this.back();
		}
	}

	private setPaymentScheduleIdForSave(id) {
		switch (+id) {
			case 0:
				return this.paymentScheduleIdFromServer;
			case -2:
			case -3:
				return null;
			default:
				return this.paymentScheduleTemplateId;
		}
	}

	private getContractToSave(): Contract {
		if (this.contractToSave) {
			this.contractToSave.name = this.stringModifierService.cutSelectedText(
				this.contractToSave.name
			);
			/* Fix changed field for GDPR */
			if (this.contractToSave.optInConsentStatement) {
				this.contractToSave.optInConsent = this.contractToSave.optInConsentStatement;
				delete this.contractToSave.optInConsentStatement;
			}
			/*
			Fix backend grammar mistake
			showOTPinconsent => showOPTinconsent
			 */
			if (this.contractToSave.showOtpInConsent) {
				this.contractToSave.showOptInConsent = this.contractToSave.showOtpInConsent;
				delete this.contractToSave.showOtpInConsen;
			}
			if (this.currentContractId === this.contractToSave.id) {
				this.contractToSave.contractId = this.currentContractId;
			} else {
				this.contractToSave.contractId = null;
			}
		}
		return this.contractToSave;
	}

	private getPaymentsToSave(): Array<QuotePayments> {
		return this.paymentsToSave.map((payment): void => {
			let paymentToSave;
			if (payment.date) {
				paymentToSave = Object.assign(payment, {
					paymentDate: this.quoteUpdateService.getDate(payment.date.jsdate)
				});
			} else if (
				!payment.date &&
				payment.paymentDateWithRule.ruleExplanationHTML
			) {
				paymentToSave = Object.assign(payment, {
					paymentDate: null
				});
			} else {
				paymentToSave = payment;
			}
			return paymentToSave;
		});
	}

	private getProductsToSave(needToRemoveId): Array<Product> {
		const productsToSave = this.packages.map((packageItem, index): Product =>
			Object.assign(packageItem, {
				id: packageItem.fromSettings && needToRemoveId ? null : packageItem.id,
				order: index,
				price: needToRemoveId
					? this.stringModifierService.convertAmountIntoNumber(
							packageItem.price
					  )
					: packageItem.price,
				mandatory: this.packages.length > 1 ? false : packageItem.mandatory
			})
		);

		this.addons.forEach((product, index): void => {
			productsToSave.push(
				Object.assign(product, {
					id: product.fromSettings && needToRemoveId ? null : product.id,
					order: index,
					price: needToRemoveId
						? this.stringModifierService.convertAmountIntoNumber(product.price)
						: product.price
				})
			);
		});
		this.discounts.forEach((discount, index): void => {
			productsToSave.push(
				Object.assign(discount, {
					id: discount.fromSettings && needToRemoveId ? null : discount.id,
					order: index,
					price: needToRemoveId
						? this.stringModifierService.convertAmountIntoNumber(discount.price)
						: discount.price,
					taxType: this.quoteUpdateService.setTaxTypeForDiscount(
						productsToSave,
						discount.taxType
					)
				})
			);
		});
		return productsToSave;
	}

	private gatherDataToSaveQuote(): any {
		let isQuestionnaireChanged = true;
		if (
			this.questionnaire &&
			+this.questionnaireToSaveId === this.questionnaire.id
		) {
			isQuestionnaireChanged = false;
		}
		if (this.quoteSummary && this.quoteSummary.total === 0) {
			this.paymentScheduleTemplateId = -2;
		}
		this.paymentsToSave = this.getPaymentsToSave();
		return {
			quote: {
				quoteId: this.quote.quoteId,
				ponumber: this.quote.ponumber,
				issueDate: this.timeService.getDateInFormat(
					this.issueDate.jsdate,
					'date'
				),
				notes: this.quote.notes,
				introduction: this.quote.introduction,
				paymentSchedulerTemplateId: this.setPaymentScheduleIdForSave(
					this.paymentScheduleTemplateId
				),
				products:
					this.quoteType === 'custom'
						? this.getProductsToSave(true)
						: this.getProductsToSaveFixedQuote(true),
				payments: this.quoteSummary.total === 0 ? [] : this.paymentsToSave,
				generateInvoiceWhenAccepted:
					this.paymentScheduleTemplateId !== -3 && this.autoGenerateInvoice,
				paymentsStrategy: this.getPaymentStrategy()
			},
			removeContract: this.contractToSave === null,
			removeQuestionnaire: this.questionnaireToSaveId === '-1',
			contract: this.getContractToSave(),
			questionnaire: isQuestionnaireChanged
				? {
						templateId:
							this.questionnaireToSaveId === '-1'
								? null
								: this.questionnaireToSaveId
				  }
				: null
		};
	}

	private getPaymentStrategy() {
		switch (this.paymentScheduleTemplateId) {
			case -2:
				return 'NO_SPLIT_PAYMENTS';
			case -3:
				return 'NO_DUE_DATE';
			default:
				return 'BY_PAYMENT_SCHEDULER';
		}
	}

	private getProductsToSaveFixedQuote(needToRemoveId): Array<Product> {
		this.products = QuoteUpdateService.setFixedQuoteProducts(this.products);
		const productsToSave = this.products.map((productItem, index): Product =>
			Object.assign(productItem, {
				id: productItem.fromSettings && needToRemoveId ? null : productItem.id,
				order: index,
				price: needToRemoveId
					? this.stringModifierService.convertAmountIntoNumber(
							productItem.price
					  )
					: productItem.price
			})
		);

		this.discounts.forEach((discount, index): void => {
			productsToSave.push(
				Object.assign(discount, {
					id: discount.fromSettings && needToRemoveId ? null : discount.id,
					order: index,
					price: needToRemoveId
						? this.stringModifierService.convertAmountIntoNumber(discount.price)
						: discount.price,
					taxType: this.quoteUpdateService.setTaxTypeForDiscount(
						productsToSave,
						discount.taxType
					)
				})
			);
		});
		return productsToSave;
	}

	private getProductsTemplates(): void {
		const pageRequest = QuoteUpdateService.getPageRequest();
		this.productPackagesDataService
			.getPackagesOrProducts(pageRequest)
			.subscribe(
				(data): void => {
					this.productsNames = data.items;
					this.setPackagesAndAddonsNames(data.items);
				},
				(error): void => this.messageService.showDefaultErrorMessage(error)
			);
	}

	private getPaymentsSchedules(): void {
		const params = QuoteUpdateService.getPaymentSchedulesPageRequest();
		this.paymentsSchedulesDataService.getPaymentsSchedules(params).subscribe(
			(data): void => {
				this.defaultPaymentScheduleNames = [
					{
						id: -2,
						name: 'No split payments',
						disabled: false
					},
					{
						id: -3,
						name: 'No payment required',
						disabled: false
					}
				];
				this.paymentScheduleNames = data.results;
			},
			(error): void => this.messageService.showDefaultErrorMessage(error)
		);
	}

	private loadQuoteTemplates(): void {
		if (this.quoteType === 'fixed') {
			this.getQuoteTemplates('getQuoteTemplatesList');
		} else {
			this.getQuoteTemplates('getCustomQuoteTemplatesList');
		}
	}

	private getQuoteTemplates(
		getMethod: 'getCustomQuoteTemplatesList' | 'getQuoteTemplatesList'
	): void {
		this.qtTemplatesDataService[getMethod](
			QuoteInvoiceTemplatesService.getTemplatesParameters()
		)
			.pipe(
				takeUntil(this.unsubscribe),
				map(
					({ data }): Array<QtTemplateListItem> =>
						(data ? data.samples.items : [])
				)
			)
			.subscribe(
				(templates: Array<QtTemplateListItem>): Array<QtTemplateListItem> =>
					(this.quoteTemplates = templates),
				(error): void => this.messageService.handleError(error)
			);
	}

	private isContractSigned(): boolean {
		const { signed, signatures } = this.contractToSave;
		if (signatures) {
			const {
				photographerSignature,
				primarySignature,
				secondarySignature
			} = signatures;
			return (
				signed ||
				photographerSignature ||
				primarySignature ||
				secondarySignature
			);
		}
		return signed;
	}

	private getQuoteIdAndDate(id: number): void {
		this.quoteDataService
			.getQuoteIdAndDate(id)
			.takeUntil(this.unsubscribe)
			.subscribe(data => {
				this.quoteId = data.quoteId;
				this.issueDate = this.quoteUpdateService.setQuoteIssueDate(
					data.issueDate
				);
				this.quote = this.quoteUpdateService.setEmptyQuote(this.quoteId);
				this.getCurrencyAndTaxes();
				this.getDefaultIntroduction();
				this.getContractAndQuestionnaireInfo();
				// TODO - refactor
				let intervalCounter = 0;
				const interval = setInterval(() => {
					if (this.currencyFlag) {
						if (this.quoteType === 'custom' && !this.editQuote) {
							this.addNewPackage();
						} else if (this.quoteType !== 'custom' && !this.editQuote) {
							this.addNewProduct();
						}
						this.currencyFlag = false;
						intervalCounter++;
					}
					if (this.contractFlag && intervalCounter == 1) {
						this.assignInitialDataAsTemplate(this.quote, this.linkedContract);
						this.contractFlag = false;
						intervalCounter++;
					}
					if (intervalCounter > 1) {
						clearInterval(interval);
					}
				}, 200);
			});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/quotes/quote-update/quote-update.ts